<template>
    <v-form>
      <v-progress-linear v-if="loading" indeterminate color="blue"></v-progress-linear>
        <v-card class="px-10 py-2"   :style="{ border: '1px solid var(--primary-boarder-color)' }">
          <v-row class="d-flex align-center">
            <p class="me-5"> Turn on/off Google Authentication</p>  
            <v-switch v-model="switchMe" class="switch" color="info"></v-switch>
          </v-row>
        </v-card>

      <v-card v-if="this.secret">
        <HeaderDividerBlock headerText="Google Authentication"></HeaderDividerBlock>
        <v-container class="pa-6">
          <v-layout row v-if="errors">
            <v-flex>
              <Alert @dismissed="onDismissed" :text="errors"></Alert>
            </v-flex>
          </v-layout>
          <v-row>
            <v-col cols="12">
              <p>Set up your two factor authentication by scanning the barcode below. Alternatively, you can use the code <strong>{{ secret }}</strong></p>
            </v-col>
            <v-col cols="12">
              <div v-html="QR"></div>
            </v-col>
            
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col cols="12" md="9" xs="6">
            </v-col>
            <v-col cols="12" md="3" xs="6">
              <v-btn large color="#00B3FF" dark depressed :loading="loading" block @click="create1()">Activate</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      
      <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
      <Snackbars :text="'Validation error please scroll up'" :snackbar="snackbarError" :color="'red'"
        @classSnackbar="closeSnackbar" />
    </v-form>
  </template>
  
  <script>
  import Alert from "@/components/shared/Alert";
  import { EmployerService } from "@/services/employer-service.js";
  import { AuthService } from "@/services/auth-service.js";
  import { checkError } from "@/config/errors.js";
  import Snackbars from "@/components/shared/Snackbars";
  import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
  
  export default {
    name: "GoogleAuthRegister",
    components: { Alert, Snackbars, HeaderDividerBlock},
    props: ["name"],
    data: () => ({
      form: {
        employer_no: "",
        full_name: "",
        email: "",
        status: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        cph: "",
        specialty: "",
      },
  
      switchM: false,
      switchMe: '',
      user: "",
      snackbar: false,
      QR:"",
      secret: null,
      user_data: "",
      snackbarError: false,
      successMsg: "Employer has been created successfully",
      errors: null,
      loading: false,
      role_names: [],
    }),
  
    watch: {
        switchMe: function(newSwitch, oldSwitch) {
            if (newSwitch !== oldSwitch) {
                this.changeEnable();
            }
        },
    },
  
    mounted() {  
      this.getUser();
    },
  
    methods: {
      create1(){
        this.loading = true;
        AuthService.updateGoogleAuth(this.user_data)
          .then((response) => {
            this.loading = false;
            if (response.data) {
            this.secret = null;
              
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            window.scrollTo(0, 0);
  
          });
      },

      changeEnable(){
        if (this.switchMe){
            if (this.user.google2fa_secret == null){
                let fd = new FormData();
                fd.append("email", this.user.email);
                this.switchM = true;
                EmployerService.createEmployer(fd)
                    .then((response) => {
                        this.switchM = false;
                        if (response.data) {
                            this.QR = response.data['QR_Image'];
                            this.secret = response.data['registration_data'].google2fa_secret;
                            this.user_data = response.data["registration_data"];
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                    });
            }else{
                this.switchM = true;
                EmployerService.updateEnableAuth()    
                this.switchM = false;
                    
            }
        }else{
            this.switchM = true;
                EmployerService.updateEnableAuth1()    
                this.switchM = false;
                if (this.secret !== null){
                  this.secret = null;
                }
        }
      },

      getUser(){
        this.loading = true;
        AuthService.getProfile()
          .then((response) => {
            this.loading = false;
            if (response.data) {
                this.user = response.data.data;
                if (this.user.enable_auth == 0){
                    this.switchMe = false;
                }else{
                    this.switchMe = true;
                }
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
  
          });
      },
      
      closeSnackbar() {
        this.snackbar = false;
      },

      onDismissed() {
        this.errors = null;
      },
  
      reset() {
        this.form = [];
      },
  
    },
  };
  </script>

<style>